module.exports = __webpack_public_path__ + "img/130.0c3f4909.jpg";